"use client";

import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

interface StartReplyPayload {
	commentId?: number;
	author?: string | null;
	postId?: number;
}

interface ReplyState {
	activeCommentId: number | null;
	activePostId: number | null;
	activeAuthor: string | null;
	startReply: (payload: StartReplyPayload) => void;
	startPostReply: (postId: number) => void;
	clearReply: () => void;
}

export const useReplyStore = create<ReplyState>()(
	subscribeWithSelector((set) => ({
		activeCommentId: null,
		activePostId: null,
		activeAuthor: null,
		startReply: ({ commentId, author }) =>
			set(() => ({
				activeCommentId: commentId ?? null,
				activePostId: null,
				activeAuthor: author ?? null,
			})),
		startPostReply: (postId) =>
			set(() => ({
				activeCommentId: null,
				activePostId: postId,
				activeAuthor: null,
			})),
		clearReply: () =>
			set(() => ({
				activeCommentId: null,
				activePostId: null,
				activeAuthor: null,
			})),
	})),
);
